import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
export function ProductSection() {
  const features = ['Plan de Nutrición Circadiana de 21 Días', 'Lista de la compra anti-inflamatoria', 'Guía de suplementación específica +35', 'Protocolo de sueño profundo', 'Bonus: Rutinas de ejercicio de 15 min (sin cardio eterno)'];
  return <section className="py-24 bg-brand-cream overflow-hidden" data-id="element-89">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-91">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative order-2 lg:order-1" data-id="element-92">
            <div className="absolute inset-0 bg-brand-gold/20 rounded-full blur-3xl transform -translate-x-10 translate-y-10" data-id="element-93"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cuSfVdBBLitknPUbtRb2M5/sos-1.png" alt="SOS Premenopausia Programa Digital" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-94" />
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-95">
            <div className="flex items-center space-x-2 mb-4" data-id="element-96">
              <Star className="w-5 h-5 text-brand-gold fill-current" data-id="element-97" />
              <Star className="w-5 h-5 text-brand-gold fill-current" data-id="element-98" />
              <Star className="w-5 h-5 text-brand-gold fill-current" data-id="element-99" />
              <Star className="w-5 h-5 text-brand-gold fill-current" data-id="element-100" />
              <Star className="w-5 h-5 text-brand-gold fill-current" data-id="element-101" />
              <span className="text-brand-warm-gray text-sm ml-2 font-medium" data-id="element-102">
                Más de 1,200 alumnas
              </span>
            </div>

            <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-dark mb-6" data-id="element-103">
              Presentamos: <br data-id="element-104" />
              <span className="text-brand-terracotta" data-id="element-105">SOS PREMENOPAUSIA</span>
            </h2>

            <p className="font-sans text-lg text-brand-warm-gray mb-8 leading-relaxed" data-id="element-106">
              El primer protocolo digital diseñado para la biología única de la
              mujer de 35 a 48 años. No es una dieta más. Es un manual de
              reparación metabólica para recuperar el control de tu cuerpo en
              menos de un mes.
            </p>

            <div className="bg-white p-8 rounded-xl border border-brand-sage/20 shadow-sm mb-8" data-id="element-107">
              <h3 className="font-serif text-xl font-bold text-brand-dark mb-4" data-id="element-108">
                Lo que conseguirás:
              </h3>
              <ul className="space-y-4" data-id="element-109">
                {features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-110">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-sage/10 flex items-center justify-center mt-0.5 mr-3" data-id="element-111">
                      <Check className="w-4 h-4 text-brand-sage" data-id="element-112" />
                    </div>
                    <span className="text-brand-dark font-medium" data-id="element-113">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-114">
              <div className="flex-1" data-id="element-115">
                <p className="text-sm text-brand-warm-gray mb-1" data-id="element-116">
                  Precio habitual:{' '}
                  <span className="line-through" data-id="element-117">$97.00 USD</span>
                </p>
                <p className="text-3xl font-bold text-brand-terracotta" data-id="element-118">
                  $6.39 USD
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}